import React from 'react';
import { ShieldCheck, UserCheck, AlertCircle } from 'lucide-react';

export const AIDisclosure: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-brand-surface/40 border-y border-brand-border relative">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="p-8 sm:p-12 rounded-3xl bg-brand-bg border border-brand-border relative overflow-hidden shadow-xl">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6">
            <div className="w-12 h-12 rounded-2xl bg-brand-primary/10 border border-brand-primary/30 flex items-center justify-center text-brand-primary shrink-0">
              <ShieldCheck className="w-6 h-6" />
            </div>
            <div>
              <span className="text-xs font-semibold uppercase tracking-wider text-brand-cyan">
                Posicionamento Ético & Responsabilidade
              </span>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-white mt-1">
                A Inteligência Artificial Como Instrumento de Engenharia
              </h2>
            </div>
          </div>

          <div className="space-y-4 text-sm text-brand-textMuted leading-relaxed">
            <p>
              O <strong className="text-white font-medium">InfoForge</strong> foi projetado com uma filosofia de produto clara: a tecnologia existe para acelerar a pesquisa, organizar a arquitetura e automatizar a formatação braçal, mas o <strong className="text-white font-medium">conhecimento autêntico e a validação final pertencem sempre ao criador</strong>.
            </p>
            <p>
              Não acreditamos nem promovemos promessas de "lucro fácil", "renda passiva sem esforço" ou "produtos milagrosos gerados em 2 minutos com 1 clique". Um infoproduto respeitável exige relevância pedagógica, método consistente e conexão com o público.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8 pt-6 border-t border-brand-border">
            <div className="flex items-start gap-3 p-4 rounded-xl bg-brand-surface/60 border border-brand-border/60">
              <UserCheck className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
              <div className="text-xs">
                <span className="font-bold text-white block mb-1">Supervisão Humana Contínua</span>
                <span className="text-brand-textSubtle">O especialista aprova os tópicos, calibra o tom de voz e revisa os entregáveis antes da publicação.</span>
              </div>
            </div>

            <div className="flex items-start gap-3 p-4 rounded-xl bg-brand-surface/60 border border-brand-border/60">
              <AlertCircle className="w-5 h-5 text-brand-cyan shrink-0 mt-0.5" />
              <div className="text-xs">
                <span className="font-bold text-white block mb-1">Sem Alucinações Soltas</span>
                <span className="text-brand-textSubtle">Nossos pipelines possuem checagem de fatos cruzada e bloqueio estrito contra invenções não fundamentadas.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
